import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-[#FFFAF5] px-4 pt-10 pb-16 md:pt-16 md:pb-24" data-id="element-62">
      <div className="max-w-5xl mx-auto" data-id="element-63">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="flex justify-center mb-8" data-id="element-64">
          <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold bg-[#FFF3D6] text-[#A84A22] border border-[#E8A838]/30" data-id="element-65">
            🇺🇸 Para padres hispanos en USA
          </span>
        </motion.div>

        {/* Hook Question */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-3xl md:text-[2.75rem] lg:text-5xl leading-tight md:leading-tight lg:leading-tight font-bold tracking-tight text-[#3D2B1F] max-w-4xl mx-auto mb-6" data-id="element-66">
          ¿Sientes que has perdido el control en tu casa y que los gritos son la
          única forma de que tus hijos te escuchen?
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="text-center text-lg md:text-xl leading-relaxed text-[#5C4A3A] max-w-3xl mx-auto mb-12" data-id="element-67">
          El método de{' '}
          <strong className="text-[#3D2B1F]" data-id="element-68">
            "Primeros Auxilios Emocionales"
          </strong>{' '}
          para padres hispanos en USA: Recupera el control en solo{' '}
          <span className="text-[#C75B2A] font-bold" data-id="element-69">4 segundos</span> — sin
          traumas y sin perder la autoridad.
        </motion.p>

        {/* Content: Image + CTA */}
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-70">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.45
        }} className="w-full lg:w-1/2 flex justify-center" data-id="element-71">
            <div className="relative" data-id="element-72">
              <div className="absolute inset-0 bg-[#C75B2A]/10 rounded-2xl blur-2xl transform translate-y-4" data-id="element-73" />
              <img src="https://cdn.magicpatterns.com/uploads/3UXDKYDiqBkdhLr3WHBiE1/portada_2.png" alt="Manual de Primeros Auxilios Emocionales para padres — madre e hijo en la cocina con tablet mostrando la portada del manual" className="relative w-full max-w-md rounded-2xl shadow-xl shadow-[#3D2B1F]/10" data-id="element-74" />
            </div>
          </motion.div>

          {/* CTA Column */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.55
        }} className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-75">
            <p className="text-[#5C4A3A] text-lg leading-relaxed mb-3" data-id="element-76">
              Entras a la tienda y sucede… Tu hijo se tira al suelo, los gritos
              comienzan y sientes cómo{' '}
              <em data-id="element-77">todas las miradas se clavan en ti</em>.
            </p>
            <p className="text-[#5C4A3A] text-lg leading-relaxed mb-3" data-id="element-78">
              El calor sube por tu cuello y tu paciencia desaparece.
            </p>
            <p className="text-[#3D2B1F] text-lg leading-relaxed font-medium mb-8" data-id="element-79">
              En ese microsegundo, tienes dos opciones: explotar y sentir la
              culpa devorándote toda la noche, o{' '}
              <span className="text-[#C75B2A] font-bold" data-id="element-80">
                activar un interruptor biológico
              </span>{' '}
              que te devuelve el control para actuar con firmeza y calma.
            </p>

            <a href="#precio" className="cta-pulse inline-block w-full sm:w-auto px-8 py-4 bg-[#C75B2A] hover:bg-[#A84A22] text-white text-lg font-bold rounded-xl transition-colors duration-200 text-center focus:outline-none focus:ring-4 focus:ring-[#C75B2A]/30" data-id="element-81">
              QUIERO RECUPERAR EL CONTROL DE MI HOGAR AHORA
            </a>

            <div className="flex items-center gap-2 mt-4 text-sm text-[#8B7565]" data-id="element-82">
              <ShieldCheckIcon className="w-4 h-4 text-[#7B9E6B]" aria-hidden="true" data-id="element-83" />
              <span data-id="element-84">Acceso inmediato tras el pago. Pago 100% seguro.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}